import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from 'react-bootstrap/FormControl';
import cx from 'classnames';
import { useDebouncedCallback } from 'use-debounce';
import Icon from '@components/@core/Icon';

const Search = ({ className, placeholder = 'Search here...', hideIcon, onChange, dataCy, ...props }) => {
    const [value, setValue] = useState(props.initial ?? '');

    useEffect(() => {
        setValue(props.initial ?? '');
    }, [props.initial]);

    const handleDebounced = useDebouncedCallback((e) => {
        if (onChange) onChange(e);
    }, 500);

    const handleChange = (e) => {
        setValue(e.target.value);
        handleDebounced(e);
    };

    return (
        <div className={cx('ds-search', className)} data-cy={dataCy}>
            <FormControl type="text" {...props} value={value} placeholder={placeholder} onChange={handleChange} autoFocus />
            {!hideIcon && <Icon name="fas fa-search" size={18} color="#343f4b" />}
        </div>
    );
};

Search.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    hideIcon: PropTypes.bool,
    dataCy: PropTypes.any,
    onChange: PropTypes.func,
};

Search.defaultProps = {
    className: '',
    placeholder: 'Search here...',
    hideIcon: false,
    dataCy: null,
    onChange: () => {},
};

export default Search;
